import { render, staticRenderFns } from "./InvestmentCompletedStep.vue?vue&type=template&id=de3aea72&scoped=true"
import script from "./InvestmentCompletedStep.vue?vue&type=script&setup=true&lang=ts"
export * from "./InvestmentCompletedStep.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./InvestmentCompletedStep.vue?vue&type=style&index=0&id=de3aea72&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de3aea72",
  null
  
)

export default component.exports